<template>
	<div class="slider-dot" :class="{ pressed }">
		<div class="slider-dot__nub"></div>
	</div>
</template>

<script>
import button from '@/mixins/button'

export default {
	name: 'SliderDot',
	mixins: [button({ scrollCancel: false })]
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.slider-dot {
	$pad: 1rem;
	$side: calc(100% + #{$pad * 2});
	width: $side;
	height: $side;
	margin: -$pad;
	padding: $pad;

	&__nub {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		border: 0.25rem solid $green-44;
		background-color: white;
	}

	&.pressed &__nub {
		background-color: $green-44;
	}
}
</style>
